import './App.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from './components/Home';
import { Footer } from './components/Footer';
import ResponsiveAppBar from './components/NavBar';
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Rusty Nail custom MUI theme — matches new copper/bar aesthetic
const rnTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#c5a26f' },
    secondary: { main: '#8c4f2e' },
    background: { default: '#0f0c08', paper: '#18140f' },
    text: { primary: '#f5f0e6', secondary: '#a89f8f' },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontFamily: 'Georgia, serif' },
    h2: { fontFamily: 'Georgia, serif' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          letterSpacing: '0.5px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={rnTheme}>
      <CssBaseline />
      <ResponsiveAppBar />
      <Router>
        <Routes>
          {/* <Route path="/banned" element={<Banned />} /> */}
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
